// extracted by mini-css-extract-plugin
module.exports = {"badgeSkeleton":"styles_badgeSkeleton__ewWiU"};